import type { Client } from '~/types';
import { formatPhone } from '../helpers/format';

export default function useSessionRecording() {
  const { $posthog } = useNuxtApp();

  return {
    recordSession() {
      if ($posthog!.sessionRecordingStarted()) return;
      $posthog!.startSessionRecording();
    },

    identifyForSessionRecording(client: Client) {
      const { email, name, phone } = client;
      $posthog!.identify(email, { name, phone: formatPhone(phone) });
    }
  };
}